import { render } from "./CommunityHome.vue?vue&type=template&id=1e90163c&scoped=true"
const script = {}

import "./CommunityHome.vue?vue&type=style&index=0&id=1e90163c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e90163c"

export default script